import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token   = localStorage.getItem('token');
    const role    = localStorage.getItem('role');
    const adminId = localStorage.getItem('admin_id');
    const name    = localStorage.getItem('admin_name');
    if (token && role) setUser({ token, role, adminId, name });
    setLoading(false);
  }, []);

  const login = ({ token, role, adminId, name }) => {
    localStorage.setItem('token',      token);
    localStorage.setItem('role',       role);
    localStorage.setItem('admin_id',   adminId ?? '');
    localStorage.setItem('admin_name', name ?? '');
    setUser({ token, role, adminId, name });
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
